export const payloadExtractor = ({ payload }) => payload;

export const metaExtractor = ({ meta }) => meta;
